(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.pw-shop-section').forEach(section => {
      const track = section.querySelector('.pw-products-carousel');
      const controls = section.querySelector('[data-pw-carousel-controls]');
      if (!track || !controls || track.dataset.carouselReady) return;
      track.dataset.carouselReady = 'true';
      const previous = controls.querySelector('[data-pw-carousel-prev]');
      const next = controls.querySelector('[data-pw-carousel-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        const overflow = track.scrollWidth > track.clientWidth + 2;
        controls.hidden = !overflow;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => track.scrollBy({left: direction * track.clientWidth, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      new ResizeObserver(update).observe(track);
      update();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();